module.exports = __webpack_public_path__ + "static/media/qrtc-quinton-rail-technology-centre-long-marston-cropped.61718221.png";